import PropTypes from 'prop-types'
import * as Types from 'types'

export const section = PropTypes.shape({
  title: PropTypes.string.isRequired,
  suggestions: PropTypes.arrayOf(Types.searchSuggestion),
})
